import { render } from "./AlmacenList.vue?vue&type=template&id=217a3691&scoped=true"
import script from "./AlmacenList.vue?vue&type=script&lang=js"
export * from "./AlmacenList.vue?vue&type=script&lang=js"

import "./AlmacenList.vue?vue&type=style&index=0&id=217a3691&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217a3691"]])

export default __exports__